import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ご利用明細 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("【2015/11/27】")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("宿泊代")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("￥12,000")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("クリーニンク:ワイシャツ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("￥4,000")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("合計")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("￥16,000")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("内消費税")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("￥123")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("内その他税")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("￥123")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("前受け金")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("￥123")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("ご請求金額")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("￥123")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" クレジット支払")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("クレジットカードで支払いいただくことで、チェックアウトを行うことができます。")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("このサイトについて")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("利用規約")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("プライバシーポリシー")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f7_navbar = _resolveComponent("f7-navbar")!
  const _component_f7_block = _resolveComponent("f7-block")!
  const _component_f7_card_header = _resolveComponent("f7-card-header")!
  const _component_f7_col = _resolveComponent("f7-col")!
  const _component_f7_row = _resolveComponent("f7-row")!
  const _component_f7_button = _resolveComponent("f7-button")!
  const _component_f7_card_content = _resolveComponent("f7-card-content")!
  const _component_f7_card = _resolveComponent("f7-card")!
  const _component_f7_link = _resolveComponent("f7-link")!
  const _component_f7_toolbar = _resolveComponent("f7-toolbar")!
  const _component_f7_page = _resolveComponent("f7-page")!

  return (_openBlock(), _createBlock(_component_f7_page, { "page-content": false }, {
    default: _withCtx(() => [
      _createVNode(_component_f7_navbar, { "back-link": "戻る" }),
      _createVNode(_component_f7_block, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_f7_card, { class: "demo-facebook-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_card_header, { class: "total" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_f7_card_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_f7_col, { style: {"text-align":"right"} }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_f7_col, { style: {"text-align":"right"} }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col),
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_f7_row, { "no-gap": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_f7_col, { width: "45" }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_f7_col, {
                            width: "55",
                            style: {"text-align":"right"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col),
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_f7_row, { "no-gap": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_f7_col, { width: "45" }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_f7_col, {
                            width: "55",
                            style: {"text-align":"right"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col),
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_f7_row, { "no-gap": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_f7_col, { width: "45" }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_f7_col, {
                            width: "55",
                            style: {"text-align":"right"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col),
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_f7_row, { "no-gap": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_f7_col, { width: "45" }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_f7_col, {
                            width: "55",
                            style: {"text-align":"right"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, { class: "total" }, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_f7_col, { style: {"text-align":"right"} }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_f7_block, { strong: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_f7_button, {
                            fill: "",
                            large: "",
                            href: "/guestRegist/"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_f7_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_f7_col, null, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_f7_toolbar, {
        tabbar: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_link, null, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_f7_link, null, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_f7_link, null, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}